import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CheckContent from '../../../CheckContent';
import FormGroup from '../../../FormGroup';
import ExchangeRates from '../../../ExchangeRates';
import ConversionUserInfoChart from "../../../ConversionUserInfoChart/ConversionUserInfoChart.container";
import { useI18n } from 'utils/I18n/context';

const ConversionItemContent = ({ 
    isEmpty: propIsEmpty, 
    data: propData, 
    loading: propLoading,
    getConversion,
    params
}) => {
    const { t } = useI18n();
    
    const [isEmpty, setIsEmpty] = useState(propIsEmpty);
    const [data, setData] = useState(propData);
    const [loading, setLoading] = useState(propLoading);

    useEffect(() => {
        if (params?.id) {
            getConversion(params.id);
        }
    }, [params?.id, getConversion]);

    useEffect(() => {
        setIsEmpty(propIsEmpty);
        setData(propData);
        setLoading(propLoading);
    }, [propIsEmpty, propData, propLoading]);

    const staticNames = t?.conversionItemPage || {};
    const staticNameLabels = t?.dataTable?.headers || {};
    const commonKeys = Object.keys(data.common || {});
    const commissionKeys = Object.keys(data.commission || {});
    const goalKeys = Object.keys(data.goal || {});
    const trackKeys = Object.keys(data.track || {});
    const paramsKeys = Object.keys(data.params || {});

    return (
        <CheckContent
            loading={loading}
            isEmpty={isEmpty}
        >
            <div className="row ibox-list-holder">
                <div className="col-sm-12 col-md-6 ibox-column-holder">
                    <div className="ibox">
                        <div className="ibox-content field-list-holder">
                            <div className="ibox-title">
                                <h5>{staticNames.generalInfo}</h5>
                            </div>
                            <div className="form-horizontal form-horizontal_flex">
                                {commonKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${staticNameLabels[key]}:`}
                                        labelClass={''}
                                        fieldClass={''}
                                    >{data.common[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="ibox">
                        <div className="ibox-content field-list-holder">
                            <div className="ibox-title">
                                <h5>{staticNames.goal}</h5>
                            </div>
                            <div className="form-horizontal form-horizontal_flex">
                                {goalKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${staticNameLabels[key]}:`}
                                        labelClass={''}
                                        fieldClass={''}
                                    >{data.goal[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="ibox">
                        <div className="ibox-content field-list-holder">
                            <div className="ibox-title">
                                <h5>{staticNames.options}</h5>
                            </div>
                            <div className="form-horizontal form-horizontal_flex">
                                {paramsKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${key}:`}
                                        labelClass={''}
                                        fieldClass={''}
                                    >{data.params[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 ibox-column-holder">
                    <div className="ibox">
                        <div className="ibox-content field-list-holder">
                            <div className="ibox-title">
                                <h5>{staticNames.commission}</h5>
                            </div>
                            <div className="form-horizontal form-horizontal_flex">
                                {commissionKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${staticNameLabels[key]}:`}
                                        labelClass={''}
                                        fieldClass={''}
                                    >{data.commission[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                    <ExchangeRates
                        data={data.currency}
                        formGroupLabelClass={''}
                        formGroupFieldClass={''}
                    />
                    <div className="ibox">
                        <div className="ibox-content field-list-holder">
                            <div className="ibox-title">
                                <h5>{staticNames.track}</h5>
                            </div>
                            <div className="form-horizontal form-horizontal_flex">
                                {trackKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${staticNameLabels[key]}:`}
                                        labelClass={''}
                                        fieldClass={''}
                                    >{data.track[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="ibox">
                        <ConversionUserInfoChart />
                    </div>
                </div>
            </div>
        </CheckContent>
    );
};

ConversionItemContent.propTypes = {
    isEmpty: PropTypes.bool,
    data: PropTypes.shape({
        common: PropTypes.object,
        commission: PropTypes.object,
        params: PropTypes.object,
        track: PropTypes.object,
        currency: PropTypes.object,
        goal: PropTypes.object
    }),
    loading: PropTypes.bool,
    getConversion: PropTypes.func,
    params: PropTypes.shape({
        id: PropTypes.string
    })
};

ConversionItemContent.defaultProps = {
    isEmpty: false,
    data: {
        common: {},
        commission: {},
        params: {},
        track: {},
        currency: {},
        goal: {}
    },
    loading: false,
    getConversion: () => {},
    params: {}
};

export default ConversionItemContent;
